// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Router from 'vue-router'
import VueIntercom from 'vue-intercom'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import VueI18n from 'vue-i18n'
import 'element-ui/lib/theme-chalk/index.css'
import '../theme/index.css'
import locale from '../node_modules/element-ui/lib/locale/lang/en'
import './styles/index.css'
import './styles/variable.less'
import axios from '@/utils/request.js'
import utils from './utils/utils'// 时间转换器
import enLocale from './i18n/en-US'
import zhLocale from './i18n/zh-CN'
import FastClick from 'fastclick'
FastClick.attach(document.body);
Vue.prototype.utils = utils
Vue.use(VueI18n)
const messages = {
  en: {
    ...enLocale
  },
  zh_CN: {
    ...zhLocale
  }
}

const i18n = new VueI18n({

  locale:JSON.parse(localStorage.getItem('lang') ) || (navigator.language&&navigator.language.toLowerCase().includes('zh-cn')?'zh_CN':navigator.language),
  messages,
  silentTranslationWarn: true
})
// 实例化i18n并引入语言文件。
// const i18n = new VueI18n({
//   locale: 'zh-CN', // 语言标识
//   messages: {
//     'zh-CN': require('@/i18n/zh-CN.js'),
//     'en-US': require('@/i18n/en-US.js')
//   }
// })

// Vue.use(VueIntercom, { appId: 'hd46brwk' }) // 测试classover2
Vue.use(VueIntercom, { appId: 'ysd0hi0c' }) // 生产

Vue.config.productionTip = false
Vue.use(ElementUI, {locale})
Vue.prototype.$http = axios

const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}
// debugger
if ((navigator.language || navigator.browserLanguage).toLowerCase().includes('zh-cn')) {
  // var _this = this
  // _this.$cookies.set('language', 'Chinese', 60 * 60 * 24 * 30)
  // _this.$i18n.locale = _this.$cookies.get('language')
  // location.reload();
} else {
  // var _this = this
  // _this.$cookies.set('language', 'English', 60 * 60 * 24 * 30)
  // _this.$i18n.locale = _this.$cookies.get('language')
}
/* eslint-disable no-new */

new Vue({
  el: '#app',
  router,
  i18n, // 挂载
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js